// extracted by mini-css-extract-plugin
module.exports = {"studyStatistics":"StudyStatistics_studyStatistics__s8fom"};